import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MappedProduct, MappedTopping, ToppingInfo } from '../../new-service/interfaces/Topping';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { FuelTypeEnum } from 'src/app/core/constants/FuelType';
import { ToppingIds } from '../../new-service/constants/ToppingDictionary';
import { FORM_KEYS } from '../../my-services/components/edit-service-modal/edit-service.service';
import { ProductKey } from 'src/app/core/enums/ProductKey';

@Component({
  selector: 'app-wash-topping-step',
  templateUrl: './wash-topping-step.component.html',
  styleUrls: ['./wash-topping-step.component.scss']
})
export class WashToppingStepComponent {

  ProductKeys = ProductKey;
  ToppingIds = ToppingIds;

  @Input() MainToppingData!: MappedTopping;
  @Input() ProductsFormArray!: FormArray;
  @Input() FuelTypeId!: FuelTypeEnum;
  @Input() ServiceForm: FormGroup | null | undefined = undefined;
  @Input() PossibleProductsIds: ToppingIds[] = [ToppingIds.INTERIOR_CAR_WASH_TOPPING, ToppingIds.EXTERIOR_CAR_WASH_TOPPING, ToppingIds.COMPLETE_CAR_WASH_TOPPING, ToppingIds.MOTORBIKE_WASH_TOPPING, ToppingIds.TUNNEL_EXTERIOR_CAR_WASH_TOPPING]
  @Output() ProductDataEmitter = new EventEmitter<any>();

  FORM_KEYS = FORM_KEYS;

  SpecializedCenterWashData: MappedProduct | undefined = undefined;
  SpecializedCenterWashProducts: MappedProduct[] | undefined = []
  TunnelWashProductsData: MappedProduct | undefined = undefined;
  TunnelWashProductsProducts: MappedProduct[] | undefined = []

  ProductSelected: MappedProduct | undefined = undefined;



  constructor() { }

  ngOnInit() {

    this.SpecializedCenterWashData = this.MainToppingData.products.find(
      x => x.id === ToppingIds.SPECIALIZED_CENTER_WASH
    );

    this.TunnelWashProductsData = this.MainToppingData.products.find(
      x => x.id === ToppingIds.TUNNEL_WASH
    );

    if (this.SpecializedCenterWashData) {
      this.SpecializedCenterWashProducts = this.SpecializedCenterWashData.relatedProducts;
    }
    if (this.TunnelWashProductsData) {
      this.TunnelWashProductsProducts = this.TunnelWashProductsData.relatedProducts;
    }

    this.setSelectedProductFromFormArray();

  }

  private setSelectedProductFromFormArray(): void {
    const foundControl = this.ProductsFormArray.controls.find(control =>
      this.PossibleProductsIds.includes(control.get('ProductKey')?.value)
    );

    if (foundControl) {
      const selectedId = foundControl.get('ProductId')?.value;

      // Buscar el producto original con ese ID
      const allPossibleProducts = [
        ...(this.SpecializedCenterWashProducts || []),
        ...(this.TunnelWashProductsProducts || [])
      ];

      this.ProductSelected = allPossibleProducts.find(p => p.id === selectedId)!;
    }
  }

  isToppingSelected(product: MappedProduct): boolean {
    const selectedProductKeys = this.ProductsFormArray.value.map(
      (product: any) => product.ProductKey
    );

    return selectedProductKeys.includes(product.productKey)
  }

  onActiveProductChange(event: boolean, product: MappedProduct) {
    if (this.ProductSelected) {
      this.removeProductFromFormArray(this.ProductSelected);
    }
    if (event) {
      this.addProductToFormArray(product);
      this.ProductSelected = product;
    } else {
      this.ProductSelected = undefined;
    }
  }

  addProductToFormArray(product: MappedProduct): void {
    const productForm = new FormGroup({
      ProductId: new FormControl(product?.id),
      ProductType: new FormControl(product?.verticalType),
      ProductKey: new FormControl(product?.productKey),
      // Amount: new FormControl(product?.Price)
      // HasTaxes: new FormControl(product?.tax)
    });

    this.ProductsFormArray.push(productForm);
  }

  removeProductFromFormArray(product: MappedProduct): void {
    const index = this.ProductsFormArray.controls.findIndex(
      control => control.get('ProductId')?.value === product.id
    );

    if (index !== -1) {
      this.ProductsFormArray.removeAt(index);
    }
  }




}
